// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"960be3bc","513":"ec331a46","703":"1bc3a105"}[chunkId] + ".chunk.js";
};